import { type CSSProperties, type FC } from "react";

import { MediaIcon, type Sizes } from "@snapchat/snap-design-system-icons";
import { IconCloud } from "@tabler/icons-react";

import { cloudOverlay, iconContainer } from "./RemoteAssetsIcon.module.css";

interface RemoteAssetsIconProps {
    size: Sizes;
}

export const RemoteAssetsIcon: FC<RemoteAssetsIconProps> = ({ size }) => {
    const px = Number(size);

    return (
        <div className={iconContainer} style={{ "--icon-size": `${px}px` } as CSSProperties}>
            <MediaIcon size={size} />
            <IconCloud
                size={px * 0.5}
                stroke={2.5}
                fill="var(--mantine-color-body)"
                color="currentColor"
                className={cloudOverlay}
            />
        </div>
    );
};
